import "antd/es/dropdown/style";
import _Dropdown from "antd/es/dropdown";
import "antd/es/tooltip/style";
import _Tooltip from "antd/es/tooltip";
import "antd/es/menu/style";
import _Menu from "antd/es/menu";
import { useIntl } from '@ant-design/pro-provider';
import React from 'react';
import { ColumnHeightOutlined } from '@ant-design/icons';
import Container from '../../container';

var DensityIcon = function DensityIcon() {
  var counter = Container.useContainer();
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(_Dropdown, {
    overlay: /*#__PURE__*/React.createElement(_Menu, {
      selectedKeys: [counter.tableSize],
      onClick: function onClick(_ref) {
        var _counter$setTableSize;

        var key = _ref.key;
        (_counter$setTableSize = counter.setTableSize) === null || _counter$setTableSize === void 0 ? void 0 : _counter$setTableSize.call(counter, key);
      },
      style: {
        width: 80
      },
      items: [{
        key: 'large',
        label: intl.getMessage('tableToolBar.densityLarger', '默认')
      }, {
        key: 'middle',
        label: intl.getMessage('tableToolBar.densityMiddle', '中等')
      }, {
        key: 'small',
        label: intl.getMessage('tableToolBar.densitySmall', '紧凑')
      }]
    }),
    trigger: ['click']
  }, /*#__PURE__*/React.createElement(_Tooltip, {
    title: intl.getMessage('tableToolBar.density', '表格密度')
  }, /*#__PURE__*/React.createElement(ColumnHeightOutlined, null)));
};

export default /*#__PURE__*/React.memo(DensityIcon);